export default {
  ready() {
    const submitButton = this.querySelector('button.tr-button[type="submit"]');
    if (!submitButton) return;

    const buttonLabel = submitButton.querySelector('.mdc-button__label');
    const originalButtonText = (buttonLabel || submitButton).textContent;
    const setButtonText = (text) => {
      (buttonLabel || submitButton).textContent = text;
    };

    this.listenTo(this, 'tr-editor:actionPending', (event) => {
      const { messages } = event.detail;

      if (messages.length > 0) {
        submitButton.disabled = true;
        setButtonText(messages[0]);
      } else {
        submitButton.disabled = false;
        setButtonText(originalButtonText);
      }
    });
  },
};
